<template>
    <div class="w-full p-0">
        <div id="old-summary" class="summary-container flex bg-white flex-row content-between p-4 mb-8" v-if="!isNewEligibility">
            <div class="flex w-full">
                <div class="flex flex-grow text-xl justify-start items-center p-4 text-center">
                    <span v-if="customer.likelihood != 'Unknown'">
                        <strong class="text-green">{{ customer.forename | capitalize }}</strong>, it looks like you have a <strong>{{ customer.likelihood }}</strong> chance of finding your loan with us today.
                    </span>
                    <span v-else>
                        <strong class="text-green">{{ customer.forename | capitalize }}</strong>, your chances are unknown right now. Don’t worry, we still find 4/5 customers a loan.
                    </span>
                </div>
            </div>
        </div>
        <div id="new-summary" class="flex flex-row content-between pt-24 md:pt-16" v-else>
            <div class="flex w-full">
                <div class="flex flex-col text-xl text-left">
                    <span class="text-green text-lg font-bold">
                        <span>{{ customer.forename }}</span>, you have a chance of finding a loan or alternative credit product through Little Loans
                    </span>
                    <div class="mt-4">
                        <div class="flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                <path d="M13.3334 4.5L6.00008 11.8333L2.66675 8.5" stroke="#3CD3AD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <p class="ml-3 text-sm">Get your no obligation instant quote in just 2 minutes</p>
                        </div>
                        <div class="flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                <path d="M13.3334 4.5L6.00008 11.8333L2.66675 8.5" stroke="#3CD3AD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <p class="ml-3 text-sm">If approved cash could be sent quickly*</p>
                        </div>
                        <div class="flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                <path d="M13.3334 4.5L6.00008 11.8333L2.66675 8.5" stroke="#3CD3AD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <p class="ml-3 text-sm">Over 2.5 million people helped&#8225;</p>
                        </div>
                    </div>
                    <p class="text-sm text-green font-bold my-4">Complete your personalised quote</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['customer'],
    data() {
        return {
            isNewEligibility: true,
        }
    },
    created() {
        // const params = new URLSearchParams(window.location.search);
        // this.isNewEligibility = params.get('ecv') === '2';
    },
}
</script>

<style lang="scss" scoped>

</style>